import React from "react";
import { HR_TOOLS } from "./HrSyncDTO";

/**
 * Informational strip: the HR systems Sustina can connect to. Logos where a
 * plain brand mark is available, a neat name tile otherwise. Shown at the top of
 * the HR & Workforce page and the people-related Social topics.
 */
export default function HrToolLogos({ title = "Connects with your HR system", compact = false }) {
  return (
    <div className={`border rounded bg-light px-3 ${compact ? "py-2" : "py-3"} mb-3`}>
      <div className="extra-small fw-bold text-uppercase text-muted mb-2" style={{ letterSpacing: "0.5px" }}>
        {title}
      </div>
      <div className="d-flex flex-wrap align-items-center gap-2">
        {HR_TOOLS.map((t) => (
          <span
            key={t.code}
            title={t.name}
            className="d-inline-flex align-items-center gap-1 bg-white border rounded px-2"
            style={{ height: compact ? 28 : 34 }}
          >
            {t.logo && <img src={t.logo} alt="" style={{ height: compact ? 14 : 18, width: "auto", opacity: 0.8 }} />}
            <span className="small fw-bold text-secondary">{t.name}</span>
          </span>
        ))}
      </div>
      {!compact && (
        <div className="extra-small text-muted mt-2">
          Names and logos belong to their owners and are shown for information only.
        </div>
      )}
    </div>
  );
}
